import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WithdrawalStatus, WithdrawType } from '@inyova/models';

@Component({
  selector: 'app-withdrawal-status',
  templateUrl: './withdrawal-status.component.html',
  styleUrls: ['./withdrawal-status.component.scss'],
  standalone: false
})
export class WithdrawalStatusComponent implements OnInit {
  @Input() isMobileApp: boolean;
  @Input() keepAccount: boolean;
  @Input() withdrawalStatus: WithdrawalStatus;
  @Input() withdrawalType: WithdrawType;
  @Output() openProfile: EventEmitter<void> = new EventEmitter<void>();
  @Output() trackActivity: EventEmitter<string> = new EventEmitter<string>();
  statusContent: { icon: string; type: string; title: string; desc: string };
  showFeedbackLoop = false;

  ngOnInit() {
    this.statusContent = this.getStatusContent(this.withdrawalStatus);
    this.showFeedbackLoop = this.withdrawalStatus === 'success' && this.withdrawalType === WithdrawType.FULL && !this.keepAccount;
  }

  onOpenProfile() {
    this.openProfile.emit();
  }

  getStatusContent(status: WithdrawalStatus) {
    if (status === 'canceled') {
      return {
        icon: 'PartyPopper',
        type: 'success',
        title: 'ACCOUNT.withdrawalV2.emotionalization.thankYou.title',
        desc: 'ACCOUNT.withdrawalV2.emotionalization.thankYou.description'
      };
    }

    if (status === 'promotion') {
      return {
        icon: 'PartyPopper',
        type: 'success',
        title: 'ACCOUNT.withdrawalV2.emotionalization.thankYou.title',
        desc: 'ACCOUNT.withdrawalV2.emotionalization.thankYou.descriptionPromo'
      };
    }

    if (status === 'success') {
      return {
        icon: 'circle-check-big',
        type: 'success',
        title: 'ACCOUNT.withdrawalV2.success.title',
        desc: ''
      };
    }

    if (status === 'fail') {
      return {
        icon: 'circle-x',
        type: 'warning',
        title: 'ACCOUNT.withdrawalV2.failure.title',
        desc: 'ACCOUNT.withdrawalV2.failure.description'
      };
    }

    return {
      icon: 'loader',
      type: 'info',
      title: 'ACCOUNT.withdrawalV2.ongoing.title',
      desc: 'ACCOUNT.withdrawalV2.ongoing.description'
    };
  }

  onTrackFeedback(message) {
    this.trackActivity.emit(message);
  }
}
